import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async index({ commit }, payload) {
    const apiResult = await apiService.get(route('member.prefecture.index'), payload)
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
}

export default {
  state,
  mutations,
  actions,
}
